/* SISCODE cart drawer UX fixes: "Continue Shopping" close-on-click, and desktop
   click-outside-to-close (Horizon's drawer intentionally has no backdrop at >=990px). */

function init() {
  document.addEventListener('click', function (event) {
    /* "Continue Shopping" (empty-cart state) is a same-page anchor link (/#shop) — a
       same-page fragment navigation doesn't reload the page, so the drawer would
       otherwise stay open, overlapping the section it just scrolled to. Close it
       explicitly and let the anchor scroll happen alongside. */
    const continueShoppingBtn = event.target.closest('.cart-items__empty-button');
    if (continueShoppingBtn) {
      const drawer = document.getElementById('cart-drawer');
      if (drawer && drawer.isOpen) drawer.close();
      return;
    }

    /* SISCODE (desktop only): Horizon's cart drawer intentionally opens as a non-modal
       "squeeze" sidebar at >=990px with no backdrop, so clicking outside never closes it
       by design. Add that behavior back in explicitly, scoped to desktop widths only. */
    if (window.matchMedia('(min-width: 990px)').matches && !event.target.closest('#ssCartToggle')) {
      const drawer = document.getElementById('cart-drawer');
      if (drawer && drawer.isOpen) {
        const panel = drawer.querySelector('dialog');
        if (panel && !panel.contains(event.target)) {
          drawer.close();
        }
      }
    }
  });
}

// Defensive: if this script (a deferred module, loaded with fetchpriority="low") happens to
// finish loading after DOMContentLoaded has already fired, waiting for that event would mean
// init() — including the click listener — never runs at all. Run immediately in that case.
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
